module.exports = __webpack_public_path__ + "static/media/java-teaching-tool-coding.68b3d87d.webp";